// Widget-Plugin: Subdashboard
var vcDashboardMenu = (function ($) {

    function build(ctx) {
        var allItems = ctx.allItems;
        var settings = ctx.settings;
        var $sidebar = ctx.$sidebar;
        var $grid = ctx.$grid;
        var $placeholder = ctx.$placeholder;
        var pushUndo = ctx.pushUndo;
        var snapToGrid = ctx.snapToGrid;
        var positionElement = ctx.positionElement;
        var addItem = ctx.addItem;
        var resolveCollisions = ctx.resolveCollisions;
        var saveConfig = ctx.saveConfig;

        var setMedia = ctx.setMedia;

        var $trash = null;


        if (!allItems.length) {
            return { $trash: null, isOverTrash: function () { return false; } };
        }

        var $sidebarContent = $("<div>").addClass("vc-list vc-grid-2col float vc-grid-margin-right float-box").css({ "flex": "1", "overflow-y": "auto", "min-height": "0" });
        var $entries = $("<div>").addClass("vc-list-table").css("border", "1px solid #ddd");

        // Filter items based on dashboard type and active state
        var filteredItems = $.grep(allItems, function (item) {
            if (item.active === false) return false;
            return true;
        });

        // Group by category
        var groups = {};
        $.each(filteredItems, function (i, item) {
            var plugin = vcDashboardRegistry.get(item.type);
            var defaults = (plugin && plugin.defaults) || {};
            var category = item.category || defaults.category || item.type;
            var categoryDef = $.grep(vcDashboardCategories || [], function (cat) { return cat.id === category; })[0];
            var menuLabel = (categoryDef && categoryDef.label) || defaults.menuLabel || category;

            if (!groups[category]) {
                groups[category] = { label: menuLabel, items: [] };
            }
            groups[category].items.push(item);
        });

        // Sort categories based on the order defined in vcDashboardCategories
        var categoryOrder = $.map(vcDashboardCategories || [], function (cat) { return cat.id; });
        var sortedCategories = Object.keys(groups).sort(function (a, b) {
            var orderA = categoryOrder.indexOf(a);
            var orderB = categoryOrder.indexOf(b);
            if (orderA === -1) orderA = categoryOrder.length;
            if (orderB === -1) orderB = categoryOrder.length;
            if (orderA !== orderB) return orderA - orderB;
            return a.localeCompare(b);
        });

        var groupIndex = 0;
        $.each(sortedCategories, function (ci, category) {
            var group = groups[category];

            var $groupHeader = $("<div>").addClass("vc-list-header color-bg-secondary").css("cursor", "pointer");
            var $headerLine = $("<div>").addClass("vc-list-item");
            var $headerCol = $("<div>").addClass("vc-list-col");
            var $arrow = $("<i class='fa-solid fa-chevron-down vc-group-arrow'></i>").css("margin-right", "6px");
            $headerCol.append($("<div>").addClass("vc-list-col-element").append($arrow).append(group.label));
            $headerLine.append($headerCol);
            $groupHeader.append($headerLine);

            var $groupItems = $("<div>").addClass("vc-list-table vc-group-items");
            if (groupIndex > 0) $groupItems.hide();

            $.each(group.items, function (i, item) {
                var $line = $("<div>").addClass("vc-list-item menu-item sidebar-item").attr("data-item-id", item.id).attr("data-type", item.type);
                if (i % 2 === 1) $line.addClass("alt");
                var $col = $("<div>").addClass("vc-list-col");
                var displayName = (item.nameKey ? vcDashboardResources.get(item.nameKey) : item.name) || item.title || "";
                if (item.unit) displayName += " [" + item.unit + "]";
                $col.append($("<div>").addClass("vc-list-col-element").html(displayName));
                $line.append($col);
                $groupItems.append($line);
            });

            // toggle group on header click
            (function ($header, $items, $arrowRef) {
                $header.on("click", function () {
                    $items.slideToggle(150);
                    $arrowRef.toggleClass("fa-chevron-right fa-chevron-down");
                    $items.find(".sidebar-item").css("pointer-events", "none");
                    setTimeout(function () {
                        $items.find(".sidebar-item").css("pointer-events", "");
                    }, 200);
                });
            })($groupHeader, $groupItems, $arrow);

            if (groupIndex === 0) {
                $arrow.removeClass("fa-chevron-right").addClass("fa-chevron-down");
            } else {
                $arrow.removeClass("fa-chevron-down").addClass("fa-chevron-right");
            }

            $entries.append($groupHeader, $groupItems);
            groupIndex++;
        });

        $sidebarContent.append($entries);
        $sidebar.append($sidebarContent);

        // Media Gallery + Trash wrapper
        var $bottomSection = $("<div>").css({ padding: "10px", "margin-top": "auto" });

        var $mediaCaption = $("<div class='sidebar-media-caption'></div>").css({ fontSize: "11px", fontWeight: "bold", marginTop: "8px", marginBottom: "4px" }).text(vcDashboardResources.get("backgroundImage"));
        var $mediaSection = $("<div class='sidebar-media-section'></div>").css({ display: "flex", alignItems: "stretch", marginBottom: "8px" });
        var $mediaInput = $("<input type='hidden' id='dashboard_media_" + Math.floor(Math.random() * 1000000) + "' value='-1'>");
        var $mediaName = $("<div class='sidebar-bg-name'></div>").css({ border: "solid 1px #dce1e8", padding: "2px 4px", marginRight: "4px", flex: "1", overflow: "hidden", whiteSpace: "nowrap", fontSize: "11px", lineHeight: "26px", textAlign: "left" });
        var $mediaPath = $("<input type='hidden' class='sidebar-bg-input' readonly>");
        $mediaSection.append($mediaName, $mediaInput, $mediaPath);
        $bottomSection.append($mediaCaption, $mediaSection);
        $mediaInput.vcGallery({
            mediaCategory: "DASHBOARD", previewWidth: 50, previewHeight: 50, formItemWidth: 35, showDetails: false, showIconsOnly: true,
            onFileChanged: function () {
                if ($mediaInput.val() === "-1" || $mediaInput.val() === -1) {
                    $mediaName.text("");
                    $mediaPath.val("");
                    setMedia(null);
                }
                saveConfig();
            }
        });

        // VCMQ: Media file chosen event
        var mediaInputId = $mediaInput.attr("id");
        _VCMQ.consume($sidebar, "vcGallery", function (event) {
            if (event.msg === 'GAL_FILE_CHOSEN') {
                if (event.values === -1) {
                    $mediaName.text("");
                    $mediaPath.val("");
                    setMedia(null);
                } else {
                    $mediaName.text(event.values.mediaName || "");
                    $mediaPath.val(event.values.mediaPath || "");
                    setMedia(event.values);
                }
                saveConfig();
            }
        });



        // Papierkorb
        $trash = $("<div class='dashboard-trash'><i class='fa-solid fa-trash'></i></div>");
        $bottomSection.append($trash);
        $sidebar.append($bottomSection);

        function isOverTrash(event) {
            if (!$trash || !$trash.length) return false;
            var trashRect = $trash[0].getBoundingClientRect();
            return event.clientX >= trashRect.left && event.clientX <= trashRect.right &&
                   event.clientY >= trashRect.top && event.clientY <= trashRect.bottom;
        }

        // Drag von Sidebar ins Grid
        $sidebar.find(".sidebar-item").each(function () {
            interact(this).styleCursor(false).draggable({
                inertia: false,
                autoScroll: false,
                listeners: {
                    start: function (event) {
                        pushUndo();
                        var $clone = $(event.target).clone().addClass("drag-clone");
                        $("body").append($clone);
                        event.target._clone = $clone[0];
                    },
                    move: function (event) {
                        var clone = event.target._clone;
                        if (clone) {
                            var x = (parseFloat(clone.getAttribute("data-x")) || 0) + event.dx;
                            var y = (parseFloat(clone.getAttribute("data-y")) || 0) + event.dy;
                            clone.style.left = (event.clientX - 40) + "px";
                            clone.style.top = (event.clientY - 15) + "px";
                            clone.setAttribute("data-x", x);
                            clone.setAttribute("data-y", y);
                        }

                        // Placeholder im Grid
                        var gridRect = $grid[0].getBoundingClientRect();
                        var relX = event.clientX - gridRect.left;
                        var relY = event.clientY - gridRect.top;

                        if (relX >= 0 && relY >= 0 && relX <= gridRect.width && relY <= gridRect.height) {
                            var itemId = event.target.getAttribute("data-item-id");
                            var itemData = null;
                            $.each(allItems, function (j, d) {
                                if (d.id === itemId) { itemData = d; return false; }
                            });
                            if (itemData) {
                                var snap = snapToGrid(relX, relY);
                                snap.col = Math.min(snap.col, settings.columns - itemData.w);
                                positionElement($placeholder, snap.col, snap.row, itemData.w, itemData.h);
                                $placeholder.show();
                            }
                        } else {
                            $placeholder.hide();
                        }
                    },
                    end: function (event) {
                        var clone = event.target._clone;
                        if (clone) {
                            $(clone).remove();
                            event.target._clone = null;
                        }
                        $placeholder.hide();

                        // Prevent immediate re-drag after drop
                        $sidebar.find(".sidebar-item").css("pointer-events", "none");
                        setTimeout(function () {
                            $sidebar.find(".sidebar-item").css("pointer-events", "");
                        }, 400);

                        // Pr�fen ob Drop im Grid
                        var gridRect = $grid[0].getBoundingClientRect();
                        var relX = event.clientX - gridRect.left;
                        var relY = event.clientY - gridRect.top;

                        if (relX >= 0 && relY >= 0 && relX <= gridRect.width && relY <= gridRect.height) {
                            var itemId = event.target.getAttribute("data-item-id");
                            var itemData = null;
                            $.each(allItems, function (j, d) {
                                if (d.id === itemId) { itemData = d; return false; }
                            });
                            if (itemData) {
                                    var snap = snapToGrid(relX, relY);

                                    // Clamp size to available space
                                    var totalRows = Math.floor($grid.height() / settings.cellHeight);
                                    var availW = settings.columns - snap.col;
                                    var availH = totalRows - snap.row;
                                    var w = Math.min(itemData.w, availW);
                                    var h = Math.min(itemData.h, availH);
                                    if (w < 1) w = 1;
                                    if (h < 1) h = 1;
                                    itemData = $.extend({}, itemData, { w: w, h: h });

                                    if (itemData.type === "subdashboard") {
                                        var uniqueSubId = "sub-" + Date.now() + "-" + Math.floor(Math.random() * 10000);
                                        itemData = $.extend(true, {}, itemData, { settings: { subId: uniqueSubId } });
                                    }
                                    addItem(itemData, snap.col, snap.row, { resolveCollisions: !itemData.allowOverlap, save: true, openSettings: true });
                                }
                            }
                    }
                }
            });
        });

        return { $trash: $trash, $mediaName: $mediaName, $mediaPath: $mediaPath, isOverTrash: isOverTrash };
    }

    return { build: build };

})(jQuery);